export const PARKING557 = require('./parking557.webp');
export const TOSA_CAROUGE = require('./TOSA_carouge.webp');

const ELEMENTS = { PARKING557: 'PARKING557', TOSA_CAROUGE: 'TOSA_CAROUGE' } as const;
export default ELEMENTS;

/* import helper
  import _PV, {PARKING557, TOSA_CAROUGE} from './image'
  */
